<template>
  <v-col>
    <div v-if="loading">{{ i18n.global.t('pages.monthlyReport.preCreateStatus.loading') }}</div>
    <div v-else class="status-container">
      <div
        v-for="item in MONTHLY_REPORT_STATUS_ITEMS"
        :key="item.key"
        class="status-item"
      >
        <span class="status-label">
          {{ i18n.global.t(`pages.monthlyReport.preCreateStatus.${item.key}`) }}
        </span>
        <span class="status-value">
          {{ status ? status[item.field as keyof typeof status] : '-' }}
        </span>
      </div>
    </div>
  </v-col>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import i18n from '@/lang/i18n';
import Api from "@/services/api/ApiServiceFabrick";
import type getMonthlyReportPreCreateStatusResponse from "@/types/responses/getMonthlyReportPreCreateStatus";
import { MONTHLY_REPORT_STATUS_ITEMS } from "@/services/consts";
import { isLaravelValidationError } from '@/types/LaravelValidationError';

const props = defineProps<{
  operationOfficeId?: number | null;
  yearMonth?: string | null;
}>();

const status = ref<getMonthlyReportPreCreateStatusResponse | null>(null);
const loading = ref(false);

async function fetchStatus() {
  if (!props.operationOfficeId || !props.yearMonth) {
    return;
  }

  loading.value = true;
  try {
    const response = await Api().getMonthlyReportPreCreateStatus({
      operation_office_id: props.operationOfficeId,
      year_month: props.yearMonth
    });
    status.value = response;
  } catch (error: unknown) {
    status.value = null;
    if (isLaravelValidationError(error)) {
      console.error(error.response);
    } else {
      console.error(error);
    }
  } finally {
    loading.value = false;
  }
}

// operationOfficeIdまたはyearMonthが変更されたとき、および初回マウント時にAPIを実行
watch([() => props.operationOfficeId, () => props.yearMonth], () => {
  fetchStatus();
}, { immediate: true });

</script>

<style scoped>
.status-container {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.status-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.status-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 4px;
}

.status-value {
  font-size: 24px;
  font-weight: bold;
  color: #333;
}
</style>
